/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Fisify API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Specifies the detail level of the image. Learn more in the
[Vision guide](https://platform.openai.com/docs/guides/vision#low-or-high-fidelity-image-understanding).
 */
export type ChatCompletionContentPartImageImageURLDetail = typeof ChatCompletionContentPartImageImageURLDetail[keyof typeof ChatCompletionContentPartImageImageURLDetail];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatCompletionContentPartImageImageURLDetail = {
  auto: 'auto',
  low: 'low',
  high: 'high',
} as const;
